'use client';

import { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import styles from '../styles/FAQ.module.css';

const FAQItem = ({ question, answer, isOpen, toggleOpen, index }) => {
  const answerRef = useRef(null);

  useEffect(() => {
    if (!answerRef.current) return;

    if (isOpen) {
      gsap.set(answerRef.current, { height: 'auto', opacity: 0 });
      gsap.from(answerRef.current, {
        height: 0,
        opacity: 0,
        duration: 0.3,
        ease: 'power2.out',
      });
      gsap.to(answerRef.current, {
        opacity: 1,
        duration: 0.3,
        ease: 'power2.out',
      });
    } else {
      gsap.to(answerRef.current, {
        height: 0,
        opacity: 0,
        duration: 0.3,
        ease: 'power2.in',
      });
    }
  }, [isOpen]);

  return (
    <div className={styles.faqItem}>
      <div 
        className={`${styles.question} ${isOpen ? styles.open : ''}`} 
        onClick={() => toggleOpen(index)}
      >
        <h3>{question}</h3>
        <div className={styles.icon}>
          {isOpen ? '-' : '+'}
        </div>
      </div>
      <div 
        className={styles.answer} 
        ref={answerRef}
        style={{ height: isOpen ? 'auto' : 0, overflow: 'hidden', opacity: isOpen ? 1 : 0 }}
      >
        {typeof answer === 'string' ? <p>{answer}</p> : answer}
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  
  const toggleOpen = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  const faqItems = [
    {
      question: "What is GameMax?",
      answer: "A decentralized Web3 platform uniting racket sports players with AI, play-to-earn rewards, and community tools, starting with pickleball."
    },
    {
      question: "What is GAM used for?",
      answer: "GAM is the governance token for platform access, rewards, and tokenized gaming in the GameMax ecosystem."
    },
    {
      question: "How do I buy GAM?",
      answer: "Connect your wallet on Base or Solana, send ETH, USDT, USDC, BNB, or SOL to GAM's wallet, and claim tokens at TGE."
    },
    {
      question: "Why Base blockchain?",
      answer: "Base offers ~$0.01 transaction fees, ~1-second confirmations, and Ethereum security—perfect for a seamless presale."
    },
    {
      question: "When does the presale end?",
      answer: "May 23, 2025 — don't miss out!"
    }
  ];
  
  return (
    <div className={styles.faqContainer}>
      <div className={styles.header}>
        <span className={styles.tag}>FAQ</span>
        <h2>Frequently Asked Questions</h2>
        <p className={styles.subtitle}>Everything you need to know about the GameMax token (GAM)</p>
      </div>
      <div className={styles.faqItems}>
        {faqItems.map((item, index) => (
          <FAQItem
            key={index}
            question={item.question}
            answer={item.answer}
            isOpen={openIndex === index}
            toggleOpen={toggleOpen}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQ; 